const MaxFrameResults = 10
const KEYPOINT_ThresholdCount = 8
//单点得分
const KEYPOINT_SCORE = 0.4

class AIDataCenter {
  constructor() {
    this.aiData = []
  }

  static getInstance() {
    if (!AIDataCenter.instance) {
      AIDataCenter.instance = new AIDataCenter()
    }
    return AIDataCenter.instance
  }
}

//0 鼻子
//1 左眼
//2 右眼
//3 左耳
//4 右耳
//5 左肩
//6 右肩
//7 左肘
//8 右肘
//9 左腕
//10 右腕
//11 左胯
//12 右胯
//13 左膝
//14 右膝
//15 左脚
//16 右脚

/**
 * 根据不同的部位得分
 */
const tipsWithKeypoint = (keyPonts, errtext) => {
  if (keyPonts.length >= 17) {
    if (
      keyPonts[5].score < KEYPOINT_SCORE &&
      keyPonts[6].score < KEYPOINT_SCORE &&
      keyPonts[11].score < KEYPOINT_SCORE &&
      keyPonts[12].score < KEYPOINT_SCORE
    ) {
      return '您已出框,请调整位置'
    }

    if (keyPonts[5].score < 0.4 && keyPonts[11].score < 0.4) {
      return '您的位置已不在中心,请往右移'
    }

    if (keyPonts[6].score < 0.4 && keyPonts[12].score < 0.4) {
      return '您的位置已不在中心,请往左移'
    }

    if (!validDataWithkeypoints(keyPonts)) {
      return '请调整你的设备,全身入境'
    }
  }
  return errtext
}

/**
 * 根据不同的部位得分
 */
const scoreWithKeypoint = (keyPonts, index) => {
  if (keyPonts.length >= 17) {
    //单个身体
    const point = keyPonts[index]
    if (index == 0 || index == 9 || index == 10 || index == 15 || index == 16) {
      if (point.score > 0.1) {
        return true
      }
    }

    if (
      index == 5 ||
      index == 6 ||
      index == 7 ||
      index == 8 ||
      index == 11 ||
      index == 12 ||
      index == 13 ||
      index == 14
    ) {
      if (point.score > 0.1) {
        return true
      }
    }

    if (point.score > 0.1) {
      return true
    }
  }
  return false
}

/**
 * 数据处理
 * START stand 站立启动 0
 * GREAT 完美 1
 * ERR 异常 2
 * 出框 3
 */
const aiTypeWithResults = (str) => {
  if (str.includes('PROCESS')) {
    return 3
  }

  if (str.includes('GREAT')) {
    return 1
  }

  if (str.includes('STAND')) {
    return 4
  }

  if (str.includes('ERR')) {
    return 2
  }

  return 0
}

/**
 * 判断keypoints数据有效性
 */
const validDataWithkeypoints = (keypoints) => {
  if (!keypoints || keypoints.length < 15) {
    return false
  }
  let count = 0
  for (let index = 0; index < keypoints.length; index++) {
    const element = keypoints[index]
    if (element.score < KEYPOINT_SCORE) {
      count++
    }
  }
  if (count > KEYPOINT_ThresholdCount) {
    return false
  }
  return true
}

/**
 * ai数据处理并展示对应的结果展示
 */
const aiResultWithData = (actionId, frameResult) => {
  if (!frameResult) {
    return null
  }
  //验证数据有效性,把处理后的数据加入到应用层
  let data = dataFilterWithFrame(actionId, frameResult)
  if (data) {
    console.log('getPoseClassifiyByAction==========', frameResult.className)
    //数组容量是当前模型MaxFrameResults倍数
    if (
      AIDataCenter.getInstance().aiData.length >
      Number(data.total_node_number) * MaxFrameResults
    ) {
      AIDataCenter.getInstance().aiData.pop()
    }

    AIDataCenter.getInstance().aiData.unshift(data)

    //出现完美
    if (aiTypeWithResults(data.current_node) == 1) {
      let goodData = aiResultWithValidData()
      if (goodData) {
        //出现完美情况数据
        AIDataCenter.getInstance().aiData = []
        return 'PERFECT'
      }
    }
  }
  return null
}

/**
 * ai结果展示
 */
const aiResultWithValidData = () => {
  let frames = AIDataCenter.getInstance().aiData
  let maxProgress = frames[0].total_node_number
  let isGood = false
  for (let index = 1; index < frames.length; index++) {
    const result = frames[index]
    //是过程帧
    if (aiTypeWithResults(result.current_node) == 3) {
      if (result.current_node_number == maxProgress) {
        maxProgress--
      }

      if (maxProgress == Number(result.total_node_number) - 2) {
        isGood = true
        break
      }
    }
  }
  return isGood
}

// const aiResultWithValidData = () => {
//   let frames = AIDataCenter.getInstance().aiData
//   let maxProgress = frames[0].total_node_number
//   let isGood = false
//   let isProgressGood = false

//   for (let index = 1; index < frames.length; index++) {
//     const result = frames[index]
//     //是过程帧
//     if (aiTypeWithResults(result.current_node) == 3) {
//       if (result.current_node_number == maxProgress) {
//         isProgressGood = true
//       }
//     }
//     if (aiTypeWithResults(result.current_node) == 4 && isProgressGood) {
//       isGood = true
//       break
//     }
//   }
//   return isGood
// }

/**
 * 过滤无效数据帧
 */
const dataFilterWithFrame = (actionId, frameData) => {
  //帧标签是否存在
  if (frameData.className) {
    let labels = frameData.className.split('_')
    //匹配动作是否相同并且结构正确,过滤非当前动作数据
    if (actionId == labels[0] && labels.length == 5) {
      let filter = {
        action_id: labels[0],
        current_node: labels[1],
        current_node_number: labels[2],
        total_node_number: labels[3],
        node_name: labels[4],
        probability: frameData.probability,
      }
      return filter
    }
  }
  return null
}

export {
  dataFilterWithFrame,
  aiResultWithValidData,
  aiResultWithData,
  aiTypeWithResults,
  validDataWithkeypoints,
  scoreWithKeypoint,
  tipsWithKeypoint,
  AIDataCenter,
}
